@if (service.loading()) {
  <div class="loading-spinner">
    @if (service.title()) {
      <ng-container [ngTemplateOutlet]="cardSpinner"></ng-container>
    } @else {
      <ng-container [ngTemplateOutlet]="basicSpinner"></ng-container>
    }
  </div>
}

<ng-template #basicSpinner>
  <bricks-progress-spinner [mode]="'indeterminate'"></bricks-progress-spinner>
  @if (service.message(); as message) {
    <span>{{ message }}</span>
  }
</ng-template>

<ng-template #cardSpinner>
  <bricks-card>
    <div class="panel">
      <bricks-progress-spinner [mode]="'indeterminate'"></bricks-progress-spinner>
      @if (service.title(); as title) {
        <h2>{{ title }}</h2>
      }
      @if (service.message(); as message) {
        <span>{{ message }}</span>
      }
    </div>
  </bricks-card>
</ng-template>
